// Cache fuer presignte Bild-URLs. Bild-Bytes liegen in MinIO; das Backend liefert
// kurzlebige presignte GET-URLs. Wir cachen sie bis kurz vor Ablauf und holen sie
// dann neu, damit <img>-Tags nicht mit abgelaufenen URLs brechen.

import { API_BASE, api } from "../lib/api.js";

interface SignedUrlResponse {
  url: string; // App-relativ (/assets/signed/...)
  expiresAt: number; // unix seconds
}

interface CachedUrl {
  url: string;
  expiresAtMs: number;
}

const REFRESH_BUFFER_MS = 30_000;
const cache = new Map<string, CachedUrl>();
const inflight = new Map<string, Promise<string>>();

function keyFor(boardId: string, assetId: string): string {
  return `${boardId}/${assetId}`;
}

export async function ensureAssetUrl(boardId: string, assetId: string): Promise<string> {
  const key = keyFor(boardId, assetId);
  const cached = cache.get(key);
  if (cached && cached.expiresAtMs - REFRESH_BUFFER_MS > Date.now()) {
    return cached.url;
  }
  const pending = inflight.get(key);
  if (pending) return pending;

  const promise = api
    .get<SignedUrlResponse>(`/api/boards/${boardId}/assets/${assetId}`)
    .then((res) => {
      // App-relativen Link auf den Backend-Origin praefixen (dev: :5173 ≠ :3030).
      const absolute = `${API_BASE}${res.url}`;
      cache.set(key, { url: absolute, expiresAtMs: res.expiresAt * 1000 });
      inflight.delete(key);
      return absolute;
    })
    .catch((err) => {
      inflight.delete(key);
      throw err;
    });
  inflight.set(key, promise);
  return promise;
}
